import shipping from '@/api/shipping'

export const setShippingPageView = ({ commit }, component) => {
  commit('setShippingPageView', component)
}

export const getShippingRegionListAPI = ({ commit }) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingRegionList(result => {
      commit('setShippingRegionList', result.data.data)
    })
  })
}

export const updateRegionStatusAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.updateRegionStatus(result => {
      dispatch('getShippingRegionListAPI', '')
      resolve(result.data)
    }, params)
  })
}

export const deleteShippingRegionAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.deleteShippingRegion(result => {
      dispatch('getShippingRegionListAPI', '')
      resolve(result.data)
    }, params)
  })
}

export const addShippingRegionAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.addShippingRegion(result => {
      if (result.data.status === 'fail') {
        resolve(result.data)
      } else {
        dispatch('getShippingRegionByIdAPI', result.data.data.shipping_id)
        resolve(result.data)
      }
    }, params)
  })
}

export const setRegionNameAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.setShippingRegionName(result => {
      resolve(result.data)
    }, params)
  })
}
export const getShippingRegionByIdAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingRegionById(result => {
      commit('setShippingRegion', result.data)
      resolve(result.data)
    }, params)
  })
}

export const setRegionId = ({commit}, params) => {
  commit('setRegionId', params)
}

export const getShippingItemAPI = ({ commit, dispatch }, shippingItemId) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingItem(result => {
      resolve(result.data.data)
    }, shippingItemId)
  })
}
export const getCountryAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.getCountry(result => {
      commit('setCountry', result.data)
      resolve(result.data)
    }, params)
  })
}

export const setShippingItemAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.setShippingItem(result => {
      dispatch('getShippingItemsAPI', params.shippingId)
      resolve(result.data.data)
    }, params)
  })
}

export const getShippingItemsAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingItems(result => {
      commit('setShippingItems', result.data)
      resolve(result.data)
    }, params)
  })
}

export const getShippingTypeAPI = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingType(result => {
      resolve(result.data.data)
    }, params)
  })
}

export const updateRegionCountryAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.updateRegionCountry(result => {
      resolve(result.data)
    }, params)
  })
}

export const deleteRegionCountryByCountryIdAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.deleteRegionCountryByCountryId(result => {
      resolve(result.data)
    }, params)
  })
}

export const setShippingRegionTypeSortAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    commit('setShippingRegionTypeSort', params.shipping_item)

    shipping.setShippingRegionTypeSort(result => {
      resolve(result.data)
    }, params)
  })
}

export const setShippingItemStatusAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.setShippingItemStatus(result => {
      dispatch('getShippingItemsAPI', params.shipping_id)
      resolve(result.data)
    }, params)
  })
}

export const deleteShippingItemAPI = ({ commit, dispatch }, params) => {
  return new Promise((resolve, reject) => {
    shipping.deleteShippingItem(result => {
      dispatch('getShippingItemsAPI', params.shipping_id)
      resolve(result)
    }, params)
  })
}

export const updateShippingRegionById = ({ commit, dispatch }, params) => {
  commit('updateShippingRegionById', params)
}

export const getAllThaiProvinceAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.getAllThaiProvice(result => {
      commit('setAllThaiProvince', result.data)
      resolve(result.data)
    }, params)
  })
}

export const getShippingThaiProvinceAPI = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shipping.getAllThaiProvice(result => {
      commit('setShippingThaiProvinceList', result.data.data)
    }, params)
  })
}

export const updateShippingTypeAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.updateShippingType(result => {
      resolve(result.data)
    }, params)
  })
}

export const updateProvinceAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.updateProvince(result => {
      resolve(result.data)
    }, params)
  })
}

export const getShippingProvinceByIdAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingProvinceById(result => {
      commit('setShippingProvince', result.data)
      resolve(result.data)
    }, params)
  })
}

export const updateShippingProvinceById = ({ commit, dispatch }, params) => {
  commit('updateShippingProvinceById', params)
}

export const deleteThaiProvinceByProvinceIdAPI = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    shipping.deleteThaiProvinceByProvinceId(result => {
      resolve(result.data)
    }, params)
  })
}

export const getDefaultShippingOtherAreaData = ({ commit }) => {
  return new Promise((resolve, reject) => {
    shipping.getDefaultShippingOtherAreaData(result => {
      resolve(result.data)
    })
  })
}

export const getShippingAllThaiProvinceByRegionIdAPI = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shipping.getShippingAllThaiProvinceByRegionId(result => {
      commit('setShippingAllThaiProvinceByRegionId', result.data.data)
      resolve(result.data)
    }, params)
  })
}

export const setTabSelected = ({ commit }, params) => {
  commit('setTabSelected', params)
}

export const setRegionListByRegionId = ({ commit }, params) => {
  commit('setShippingRegionList', params)
}

export const saveShippingItemList = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shipping.saveShippingItemList(result => {
      resolve(result.data)
    }, params)
  })
}

export const deleteShippingItemList = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shipping.deleteShippingItemList(result => {
      resolve(result.data)
    }, params)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/shipping/actions.js